const TERMS = {
  DIGITIZE_PAGES: [
    {
      label: 'Digitize',
      value: 'digitize',
      path: 'media-digitizing-service',
    },
    {
      label: 'Tape Transfer',
      value: 'tapeTransfer',
      path: 'convert-vhs-tapes-to-digital-dvd',
    },
    {
      label: 'Audio Transfer',
      value: 'audioTransfer',
      path: 'convert-cassette-to-cd',
    },
    {
      label: 'Film transfer',
      value: 'filmTransfer',
      path: 'transfer-8mm-film-to-digital-dvd',
    },
    {
      label: 'Digital Transfer',
      value: 'digitalTransfer',
      path: 'dvd-to-digital-service',
    },
    {
      label: 'Photo Scan',
      value: 'photoScan',
      path: 'photo-scanning-service',
    },
  ],
  ENHANCE_PAGES: [
    {
      label: 'Enhance',
      value: 'enhance',
      path: 'restore-retouch-photo-service',
    },
    {
      label: 'Photo Restoration',
      value: 'photoRestoration',
      path: 'old-photo-restoration',
    },
    {
      label: 'Photo Colorization',
      value: 'photoColorization',
      path: 'colorize-old-black-and-white-photos',
    },
    {
      label: 'Photo Retouching',
      value: 'photoRetouching',
      path: 'photo-retouching-service',
    },
  ],
  CREATE_PAGES: [
    {
      label: 'Create',
      value: 'create',
      path: 'create-photo-art',
    },
    {
      label: 'Story Art',
      value: 'personalized-wall-art-books',
      path: 'personalized-wall-art-books',
    },
    {
      label: 'Create editor',
      value: 'photoArtEditor',
      path: 'photo_art',
    },
  ],
  GIFT_PAGES: [
    {
      label: 'Gift Card',
      value: 'giftCard',
      path: 'gift-cards',
    },
    {
      label: 'Gift Guide',
      value: 'giftGuide',
      path: 'gift-guide',
    },
  ],
  PRESERVE_PAGES: [
    {
      label: 'Preservation',
      value: 'preservation',
      path: 'preservation',
    },
    {
      label: 'Forever cloud',
      value: 'foreverCloud',
      path: 'forever-cloud',
    },
  ],
  FLORIDA_PAGES: [
    {
      label: 'Florida',
      value: 'florida',
      path: 'south-florida-media-digitizing-service',
    },
    {
      label: 'Florida Tape Transfer',
      value: 'floridaTapeTransfer',
      path: 'south-florida-vhs-tape-transfer-service',
    },
    {
      label: 'Florida Photo Scan',
      value: 'floridaPhotoScan',
      path: 'south-florida-old-photo-scanning-service',
    },
    {
      label: 'Florida Film Transfer',
      value: 'floridaFilmTransfer',
      path: 'south-florida-film-transfer-service',
    },
    {
      label: 'Florida Audio Transfer',
      value: 'floridaAudioTransfer',
      path: 'south-florida-cassette-conversion-service',
    },
    {
      label: 'Boca Raton frame shop',
      value: 'bocaRatonFrameStoreGiftShop',
      path: 'boca-raton-frame-store-gift-shop',
    },
  ],
  INFO_PAGES: [
    {
      label: 'Business Services',
      value: 'businessServices',
      path: 'professional-media-archiving-printing',
    },
    {
      label: 'Story',
      value: 'story',
      path: 'our-story',
    },
    {
      label: 'Mission',
      value: 'mission',
      path: 'our-team',
    },
    {
      label: 'How it works',
      value: 'howItWorks',
      path: 'how-digitizing-and-enhancing-works',
    },
    {
      label: 'Contact',
      value: 'contact',
      path: 'contact',
    },
    {
      label: 'Reviews',
      value: 'reviews',
      path: 'reviews',
    },
    {
      label: 'Forever Care',
      value: 'forever-care',
      path: 'forever-care',
    },
    {
      label: 'Blog',
      value: 'blog',
      path: 'blog',
    },
    {
      label: 'Terms and Conditions',
      value: 'termsAndConditions',
      path: 'terms-and-conditions',
    },
    {
      label: 'Privacy Policy',
      value: 'privacyPolicy',
      path: 'privacy-policy',
    },
    {
      label: 'Home page',
      value: '/',
      path: '/',
    },
    {
      label: 'Cart',
      value: 'cart/checkout',
      path: 'cart/checkout',
    },
    {
      label: 'Payment - login',
      value: 'payment/login',
      path: 'payment/login',
    },
    {
      label: 'Payment - checkout',
      value: 'payment/checkout',
      path: 'payment/checkout',
    },
  ],
  ACCOUNT_PAGES: [
    {
      label: 'My cloud - No membership',
      value: 'accountMyFiles',
      path: 'account?main=myFiles&tab=myFiles',
    },
    {
      label: 'My cloud + Membership',
      value: 'accountMyFilesMembership',
      path: 'account?main=myFiles&tab=myFilesMembership',
    },
    {
      label: 'My Orders',
      value: 'accountOrdersList',
      path: 'account?main=orderDetails&tab=ordersList',
    },
    {
      label: 'Order details',
      value: 'accountOrderDetails',
      path: 'account?main=orderDetails&tab=orderDetails',
    },
    {
      label: 'Order Track',
      value: 'accountOrderTrack',
      path: 'account?main=orderDetails&tab=trackOrder',
    },
    {
      label: 'My Proofs',
      value: 'accountProofs',
      path: 'account?main=proofs&tab=proofs',
    },
    {
      label: 'Make Art',
      value: 'makeArt',
      path: 'account?main=createWizard&tab=create',
    },
    {
      label: 'Shared cloud',
      value: 'sharedCloud',
      path: 'shared-cloud-files',
    },
  ],
  WIZARDS: [
    {
      label: 'Tape Transfer',
      value: 'tapeTransfer',
      path: 'tape_transfer',
    }, {
      label: 'Film Transfer',
      value: 'filmTransfer',
      path: 'film_transfer',
    }, {
      label: 'Audio Transfer',
      value: 'audioTransfer',
      path: 'audio_transfer',
    }, {
      label: 'Digital Transfer',
      value: 'digitalTransfer',
      path: 'digital_transfer',
    }, {
      label: 'Photo Scan',
      value: 'photoScan',
      path: 'photo_scan',
    }, {
      label: 'Photo Restoration/Colorization',
      value: 'photoRestoration',
      path: 'photo_restoration',
    }, {
      label: 'Photo Retouching',
      value: 'photoRetouching',
      path: 'photo_retouching',
    },
  ],
  SECTION_MEMBER: {
    name: 'order Section',
  },
  SAVE: 'Save',
  CANCEL: 'Cancel',
  SHOULD_BE_FILLED: 'Should be filled',
  TITLE: 'Title',
  AT_LEAST_ONE_IMAGE: 'Should be at least one image',
  ADD_VIDEO: 'Add Video Iframe',
  ADD: 'Add Video',
};

export default TERMS;
